import { Rule, Ruleset } from 'entities/campaign';
import { Channel } from 'entities/campaign/rulesets/channels';
import { GenericAction } from 'services/genericAPIGatewayService';
import { Service } from '../services';

export enum Types {
  RULE_ADDED = 'Rulesets:RuleAdded',
  RULE_EDITED = 'Rulesets:RuleEdited',
  RULE_DELETED = 'Rulesets:RuleDeleted',

  RULESET_CLONED = 'Rulesets:RulesetCloned',

  CHANNEL_ADDED = 'Rulesets:ChannelAdded',
  CHANNEL_CHANGED = 'Rulesets:ChannelChanged',
  CHANNEL_DELETED = 'Rulesets:ChannelDeleted',
}

export interface RuleAdded {
  type: Types.RULE_ADDED;
  payload: {
    rulesetId: string;
    rule: Rule;
  };
}

export interface RuleEdited {
  type: Types.RULE_EDITED;
  payload: {
    rulesetId: string;
    ruleIndex: number;
    changes: Rule;
  };
}

export interface ChannelAdded {
  type: Types.CHANNEL_ADDED;
  payload: {
    rulesetId: string;
    channel: Channel;
  };
}

export interface RuleDeleted {
  type: Types.RULE_DELETED;
  payload: {
    rulesetId: string;
    ruleIndex: number;
  };
}

export interface RulesetCloned {
  type: Types.RULESET_CLONED;
  payload: {
    rulesetId: string;
  };
}

export interface ChannelChanged {
  type: Types.CHANNEL_CHANGED;
  payload: {
    rulesetId: string;
    channelIndex: number;
    channel: Channel;
  };
}

export interface ChannelDeleted {
  type: Types.CHANNEL_DELETED;
  payload: {
    rulesetId: string;
    channelIndex: number;
    cycleId: string;
  };
}

export type Action =
  | GenericAction<Ruleset, Service.Rulesets>
  | ChannelChanged
  | ChannelAdded
  | ChannelDeleted
  | RuleAdded
  | RuleEdited
  | RuleDeleted
  | RulesetCloned;
